export const currencyNormalizerCreator = (
  value: string | number,
  currency: string
) => (!value ? '' : `${getCurrencySymbolByCurrency(currency)} ${value}`)

export const createFixedFloatNormalizer = (fixedValue: number) => (
  value: string | number
) => (value || `${value}` === '0' ? (+value).toFixed(fixedValue) : '')

export const getCurrencySymbolByCurrency = (currency = '') => {
  switch (currency) {
    case 'GBP':
      return '£'
    case 'EUR':
      return '€'
    case 'INR':
      return '₹'
    case 'JMD':
      return 'J$'
    case 'NZD':
      return 'NZ$'
    case 'MYR':
      return 'RM'
    case 'MXN':
      return 'Mex$'
    case 'SGD':
      return 'S$'
    case 'AUD':
      return 'A$'
    case 'ZAR':
      return 'R'
    case 'ke':
      return 'Ksh'
    case 'TRY':
      return '₺'
    case 'CAD':
      return 'CA$'
    case 'THB':
      return '฿'
    case 'ISK':
      return 'Kr'
    case 'SEK':
      return 'kr'
    default:
      return 'US$'
  }
}

export const removePlusSign = (string = '') => string.replace('+', '')
